import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface FilterState {
  selectedPartners: Set<any>;
  selectedCountries: Set<any>;
  selectedProductsList: Set<any>;
  selectedDirectionsList: Set<any>;
  selectedDirection: string;
  selectedPartnerCodes: Set<any>;
  selectedCountryName: Set<any>;
  PartnerNames: string;
  CountryNames: string;
  enablePartnerDropdown: boolean;
  enableCountriesDropdown: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FilterStateService {
  private initialState: FilterState = {
    selectedPartners: new Set(),
    selectedCountries: new Set(),
    selectedProductsList: new Set(),
    selectedDirectionsList: new Set(),
    selectedDirection: 'Select',
    selectedPartnerCodes: new Set(),
    selectedCountryName: new Set(),
    PartnerNames: 'Partner (Select direction first)',
    CountryNames: 'Country (Select direction first)',
    enablePartnerDropdown: false,
    enableCountriesDropdown: false
  };

  private filterState = new BehaviorSubject<FilterState>(this.initialState);

  getFilterState() {
    return this.filterState.asObservable();
  }

  updateFilterState(newState: Partial<FilterState>) {
    this.filterState.next({
      ...this.filterState.value,
      ...newState
    });
  }

  resetFilterState() {
    this.filterState.next(this.initialState);
  }
} 